import React, { forwardRef, useEffect, useRef } from 'react';

/**
 * MUI X DataGrid `slots.baseCheckbox` implementation using a native input.
 * Forwards the ref to a wrapper span so `element.querySelector('input')` works (DataGrid focus).
 */
const DataGridBaseCheckbox = forwardRef(function DataGridBaseCheckbox(props, ref) {
  const {
    checked,
    indeterminate,
    onChange,
    onKeyDown,
    tabIndex,
    className,
    disabled,
    inputProps = {},
    touchRippleRef: _touchRippleRef,
    style,
    ...rest
  } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);

  return (
    <span ref={ref} className={className} style={style} {...rest}>
      <input
        ref={inputRef}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
        disabled={disabled}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          accentColor: 'var(--joy-palette-primary-500, #5f09c2)',
          width: 18,
          height: 18,
          margin: 0,
          verticalAlign: 'middle',
        }}
        {...inputProps}
      />
    </span>
  );
});

export default DataGridBaseCheckbox;
